const SESSION_KEY = "bandung";
const REMEMBER_SIGNIN_KEY = "bandung-remember-signin";

let prefix = null;
let session = JSON.parse(localStorage.getItem(SESSION_KEY));
let rememberSignin = JSON.parse(localStorage.getItem(REMEMBER_SIGNIN_KEY));

const getPrefix = () => prefix ?? "";
const setPrefix = (newPrefix) => {
  prefix = newPrefix;
};

const getSession = () => session;
const setSession = (newSession) => {
  session = newSession;
  localStorage.setItem(SESSION_KEY, JSON.stringify(newSession));
};
const clearSession = () => setSession(null);
const validSession = () => !!(session && session.passcode);

const getSessionToken = () => getSession()?.sessionToken ?? "";
const getSessionUserEntityId = () => getSession()?.userEntityId ?? "";

const getRememberSignin = () => rememberSignin;
const setRememberSignin = (remember) => {
  rememberSignin = remember;
  localStorage.setItem(REMEMBER_SIGNIN_KEY, JSON.stringify(remember));
};

const getAdminPermission = () => {
  const session = getSession();
  if (session && session.administrator !== undefined) {
    return session.administrator;
  } else {
    return false;
  }
};
const getEditorPermission = () => {
  const session = getSession();
  if (session && session.editor !== undefined) {
    return session.editor;
  } else {
    return false;
  }
};
const getManagerPermission = () => {
  const session = getSession();
  if (session && session.manager !== undefined) {
    return session.manager;
  } else {
    return false;
  }
};

export {
  clearSession,
  getAdminPermission,
  getEditorPermission,
  getManagerPermission,
  getPrefix,
  getRememberSignin,
  getSession,
  getSessionToken,
  getSessionUserEntityId,
  setPrefix,
  setRememberSignin,
  setSession,
  validSession,
};
